module.exports = __webpack_public_path__ + "img/office-icon-inactive.eb57e898.svg";